import { OptionLabelValueSchema } from 'screens/LetUsHelp/utils/schemas';
import { z } from 'zod';

export const ConfigRequirementsSchema = z.object({
  preferred_carriers: z.array(OptionLabelValueSchema).optional(),
  exclude_carriers: z.array(OptionLabelValueSchema).optional(),
  ip_type: OptionLabelValueSchema,
  ip_block: OptionLabelValueSchema.optional(),
  term: OptionLabelValueSchema,
  download: OptionLabelValueSchema,
  save_default: z.boolean().optional(),
});

export type ConfigRequirements = z.infer<typeof ConfigRequirementsSchema>;

export const CompanyPreferencesRequestSchema = z.object({
  product_type: z.string().nullable().optional(),
  term: z.string().nullable().optional(),
  min_download: z.string().nullable().optional(),
  max_download: z.string().nullable().optional(),
  include_carriers: z.array(z.string()).nullable().optional(),
  exclude_carriers: z.array(z.string()).nullable().optional(),
  preferred_carriers: z.array(z.string()).nullable().optional(),
  ip_type: z.string().nullable().optional(),
  ip_block: z.string().nullable().optional(),
  include_mns: z.boolean().nullable().optional(),
  save_preferences: z.boolean().nullable().optional(),
});

export type CompanyPreferencesRequest = z.infer<
  typeof CompanyPreferencesRequestSchema
>;

export const CompanyPreferencesResponseSchema = z.object({
  id: z.string().uuid().nullable().optional(),
  group_id: z.string().nullable().optional(),
  user_id: z.string().nullable().optional(),
  min_download: z.string().nullable().optional(),
  max_download: z.string().nullable().optional(),
  term: z.string().nullable().optional(),
  include_carriers: z.array(z.string()).nullable().optional(),
  exclude_carriers: z.array(z.string()).nullable().optional(),
  preferred_carriers: z.array(z.string()).nullable().optional(),
  ip_type: z.string().nullable().optional(),
  ip_block: z.string().nullable().optional(),
  include_mns: z.boolean().nullable().optional(),
  created_at: z.string().datetime().nullable().optional(),
  updated_at: z.string().datetime().nullable().optional(),
});

export type CompanyPreferencesResponse = z.infer<
  typeof CompanyPreferencesResponseSchema
>;
